module.exports = __webpack_public_path__ + "static/media/arrow-back.c2381066.svg";